import React from "react";
import imageUrl from "utils/imageUrl";
import { Link } from "react-router-dom";
import {
  NftDetails,
  BuyPropGallery,
  Faq,
  PropertyFeatures,
  SocialLinks,
} from "components";

function BuyCardDetails() {
  return (
    <>
      <section className="p__details faq section__space__bottom section__space__top">
        <div className="container">
          <div className="p__details__area">
            <div className="row">
              <div className="col-lg-7">
                <div className="property__item__image column__space--secondary">
                  <div className="img__effect">
                    <Link to="/all-collections">
                      <img src={imageUrl("property/san.png")} alt="Mezzo " />
                    </Link>
                  </div>
                </div>

                <div className="p__details__content">
                  <div className="intro d-flex">
                    <div>
                      <h3>Mezzo</h3>

                      <p>
                        <i className="fa-solid fa-location-dot"></i> Gelugor ,
                        Penang
                      </p>
                    </div>
                    <div>
                      <a
                        href="#gallery"
                        className="button button--effect button--secondary height"
                      >
                        <i className="fa-solid fa-images"></i> Browse Gallery
                      </a>
                    </div>
                  </div>
                  <div className="group__one">
                    <h4>THE ULTIMATE EXPRESSION OF MODERN LUXURY</h4>
                    <p>
                      Some may regard this as the supreme sea view home, the
                      perfect place for modern living, or even the best of all
                      worlds… but here, you can simply call it Mezzo.
                      <br />
                      <br />
                      Conceptualised with the multi-faceted lifestyles of
                      today’s modern elites in mind, Mezzo is envisioned as the
                      ultimate home for those who seek not only luxury and
                      exclusivity but also an exciting lifestyle and modern
                      experiences that extend well beyond the confines of the
                      residence itself.
                    </p>
                  </div>
                  <PropertyFeatures />
                  <NftDetails />
                  <Faq />
                  <div className="group__one">
                    <div className="map__wrapper">
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d20342.411046372905!2d-74.16638039276373!3d40.719832743885284!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2sbd!4v1649562691355!5m2!1sen!2sbd"
                        width="746"
                        height="312"
                        allowfullscreen=""
                        loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade"
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="p__details__sidebar">
                  <div className="intro">
                    <div className="countdown__wrapper">
                      <p className="secondary">
                        <i class="fa-solid fa-hashtag"></i> Unit No : 300
                      </p>

                      <div className="progress__type progress__type--two">
                        <div className="project__info">
                          <p className="project__has">
                            <i class="fa-solid fa-house"></i> : Apartment 138
                          </p>
                          <p className="project__goal">
                            <i class="fa-solid fa-building"></i> Tower : #421
                          </p>
                        </div>
                      </div>
                    </div>
                    <h5>
                      Price:{" "}
                      <span>
                        50 ETH <span>RM64866.50</span>
                      </span>
                    </h5>
                    <div className="progress__type progress__type--two">
                      <div className="project__info">
                        <p className="project__has">Type : Commercial</p>
                        <p className="project__goal">Size : 900 sqft</p>
                      </div>
                    </div>
                  </div>
                  <div className="group brin">
                    <h5 className="neutral-top">Owned By</h5>
                    <span>0x495f...7b5e</span>
                    <div className="acus__content">
                      <form action="#" method="post">
                        <div className="item__security">
                          <div className="icon__box">
                            <img
                              src={imageUrl("icons/home.png")}
                              alt="Security"
                            />
                          </div>
                          <div className="item__security__content">
                            <p className="secondary">Security</p>
                            <h6>1st-Rank Mortgage</h6>
                          </div>
                        </div>
                        <div className="suby text-center">
                          {/* <h5>500</h5> */}
                          <Link to="/buy-prop-details/select-payment">
                            <button
                              type="submit"
                              className="button button--effect "
                            >
                              Buy Now
                            </button>
                          </Link>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="group brini">
                    <h5 className="neutral-top">About Creator</h5>
                    <hr />
                    <p>
                      The NFT market is changing rapidly and we try to make
                      something unique for you every day, so we created these
                      amazing art to convey one thought: we are all so
                      different, but still the same. It is enough to look at our
                      nft and you will not be able to tear yourself away. This
                      collection is for those who understand themselves and are
                      ready to discover something new, each art is unique in its
                      own way and it will be a great addition to your
                      collection.
                      <br />
                      Subscribe to our social networks to find out more. In
                      recent days we have worked very closely and are ready to
                      present you a new collection of great or famous people.
                      This collection is filled with tradition and we hope it
                      will please you as much as it pleasing us.
                    </p>
                  </div>
                  <SocialLinks />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <BuyPropGallery />
    </>
  );
}

export default BuyCardDetails;
